import { useTranslation as originalHook } from 'react-i18next'

export const useTranslation = () => originalHook('global')
